import React from 'react';
import { Link } from 'react-router-dom';
import Serviceimg1 from '../../assets/images/resources/service-two-hover-img-1.jpg'
import Serviceimg2 from '../../assets/images/resources/service-two-hover-img-2.jpg'
import Serviceimg3 from '../../assets/images/resources/service-two-hover-img-3.jpg'
import Serviceimg4 from '../../assets/images/resources/service-two-hover-img-4.jpg'
import Serviceimg5 from '../../assets/images/resources/service-two-hover-img-5.jpg'
import Serviceimg6 from '../../assets/images/resources/service-two-hover-img-6.jpg'

function ServiceTwo() {
  return (
    <div>
      <section className="service-two">
        <div className="container">
          <div className="service-two-title-box">
            <div className="section-two-title text-center">
              <div
                className="section-two-title-text wow fadeInUp animated"
                data-wow-duration="1500ms"
                data-wow-delay="100ms"
              >
                <p>Popular SEO Services</p>
              </div>
              <div
                className="section-two-title-title wow fadeInUp animated"
                data-wow-duration="1500ms"
                data-wow-delay="300ms"
              >
                <h2>
                  Grow Leads and Sales with insanely Good SEO Strategy
                </h2>
              </div>
            </div>
          </div>
          <div className="service-two-info-box">
            <div
              className="service-two-single service-two-hover-item wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="400ms"
            >
              <div className="service-two-single-number">
                <span>01</span>
              </div>
              <div className="service-two-single-icon">
                <i className="icon-keyword" />
              </div>
              <div className="service-two-single-title-box">
                <h4>Keyword Research</h4>
                <p>Sed ut perspiciatis unde omnis natus doloremque</p>
              </div>
              <div className="service-two-single-btn">
                <Link to="/service">
                  <i className="icon-arrow-right-up" />
                </Link>
              </div>
              <div className="service-two-hover-item-box">
                <img
                  src={Serviceimg1}
                  alt="team-item-hover"
                  className=" service-two-hover-item-box-img"
                />
              </div>
            </div>
            <div
              className="service-two-single service-two-hover-item wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="500ms"
            >
              <div className="service-two-single-number">
                <span>02</span>
              </div>
              <div className="service-two-single-icon">
                <i className="icon-web-optimization" />
              </div>
              <div className="service-two-single-title-box">
                <h4>Web Optimization</h4>
                <p>Sed ut perspiciatis unde omnis natus doloremque</p>
              </div>
              <div className="service-two-single-btn">
                <Link to="/service">
                  <i className="icon-arrow-right-up" />
                </Link>
              </div>
              <div className="service-two-hover-item-box">
                <img
                  src={Serviceimg2}
                  alt="team-item-hover"
                  className=" service-two-hover-item-box-img"
                />
              </div>
            </div>
            <div
              className="service-two-single service-two-hover-item wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="600ms"
            >
              <div className="service-two-single-number">
                <span>03</span>
              </div>
              <div className="service-two-single-icon">
                <i className="icon-enterprise" />
              </div>
              <div className="service-two-single-title-box">
                <h4>Enterprise SEO</h4>
                <p>Sed ut perspiciatis unde omnis natus doloremque</p>
              </div>
              <div className="service-two-single-btn">
                <Link to="/service">
                  <i className="icon-arrow-right-up" />
                </Link>
              </div>
              <div className="service-two-hover-item-box">
                <img
                  src={Serviceimg3}
                  alt="team-item-hover"
                  className=" service-two-hover-item-box-img"
                />
              </div>
            </div>
            <div
              className="service-two-single service-two-hover-item wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="700ms"
            >
              <div className="service-two-single-number">
                <span>04</span>
              </div>
              <div className="service-two-single-icon">
                <i className="icon-competitor-analysis" />
              </div>
              <div className="service-two-single-title-box">
                <h4>Competitive Analysis</h4>
                <p>Sed ut perspiciatis unde omnis natus doloremque</p>
              </div>
              <div className="service-two-single-btn">
                <Link to="/service">
                  <i className="icon-arrow-right-up" />
                </Link>
              </div>
              <div className="service-two-hover-item-box">
                <img
                  src={Serviceimg4}
                  alt="team-item-hover"
                  className=" service-two-hover-item-box-img"
                />
              </div>
            </div>
            <div
              className="service-two-single service-two-hover-item wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="800ms"
            >
              <div className="service-two-single-number">
                <span>05</span>
              </div>
              <div className="service-two-single-icon">
                <i className="icon-data-report" />
              </div>
              <div className="service-two-single-title-box">
                <h4>Reporting Dashboard</h4>
                <p>Sed ut perspiciatis unde omnis natus doloremque</p>
              </div>
              <div className="service-two-single-btn">
                <Link to="/service">
                  <i className="icon-arrow-right-up" />
                </Link>
              </div>
              <div className="service-two-hover-item-box">
                <img
                  src={Serviceimg5}
                  alt="team-item-hover"
                  className=" service-two-hover-item-box-img"
                />
              </div>
            </div>
            <div
              className="service-two-single service-two-hover-item wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="900ms"
            >
              <div className="service-two-single-number">
                <span>06</span>
              </div>
              <div className="service-two-single-icon">
                <i className="icon-setting" />
              </div>
              <div className="service-two-single-title-box">
                <h4>Technical Audit</h4>
                <p>Sed ut perspiciatis unde omnis natus doloremque</p>
              </div>
              <div className="service-two-single-btn">
                <Link to="/service">
                  <i className="icon-arrow-right-up" />
                </Link>
              </div>
              <div className="service-two-hover-item-box">
                <img
                  src={Serviceimg6}
                  alt="team-item-hover"
                  className=" service-two-hover-item-box-img"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ServiceTwo
